(function() {
  'use strict';

  function initPDP(root) {
    if (!root || root.__edmePdpInit) return;
    root.__edmePdpInit = true;

    var form = root.querySelector('[data-pdp-form]');
    var variantInput = root.querySelector('[data-pdp-variant-id]');
    var skuEl = root.querySelector('[data-pdp-sku]');
    var atcBtn = root.querySelector('[data-pdp-atc]');
    var atcText = root.querySelector('[data-atc-text]');
    var sizeBtns = root.querySelectorAll('.edme-pdp__size');

    // Fiyat alanı — varyant değişince güncellenecek
    var priceContainer = root.querySelector('[data-pdp-price]');

    // Panelden gelen etiketleri butonun data-* attribute'larından oku
    // (Liquid bunları render etmiş durumda — büyük/küçük harf duyarlı)
    var atcLabelAvailable = atcBtn ? (atcBtn.getAttribute('data-label-available') || 'Sepete Ekle') : 'Sepete Ekle';
    var atcLabelUnavailable = atcBtn ? (atcBtn.getAttribute('data-label-unavailable') || 'Stoklara Geldiğinde Haber Ver') : 'Stoklara Geldiğinde Haber Ver';

    // === FİYAT GÜNCELLEME ===
    // Beden değiştiğinde varyantın fiyatını ve compare_at_price'ını ekrana yansıt.
    // Compare price varsa "indirimli" görünüm (üstü çizili eski fiyat + kırmızı yeni fiyat),
    // yoksa "normal" görünüm (tek fiyat).
    function updatePrice(btn) {
      if (!priceContainer || !btn) return;

      var priceFormatted = btn.getAttribute('data-price') || '';
      var compareFormatted = btn.getAttribute('data-compare-price') || '';
      var priceRaw = parseFloat(btn.getAttribute('data-price-raw')) || 0;
      var compareRaw = parseFloat(btn.getAttribute('data-compare-price-raw')) || 0;

      // İndirim var mı? (compare > price)
      var onSale = compareRaw > 0 && compareRaw > priceRaw;

      if (onSale) {
        priceContainer.innerHTML =
          '<span class="edme-pdp__price-compare" data-pdp-price-compare>' + compareFormatted + '</span>' +
          '<span class="edme-pdp__price-sale" data-pdp-price-current>' + priceFormatted + '</span>';
      } else {
        priceContainer.innerHTML =
          '<span class="edme-pdp__price-regular" data-pdp-price-current>' + priceFormatted + '</span>';
      }
    }

    // === SIZE SELECTION ===
    sizeBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        var available = btn.getAttribute('data-available') === 'true';
        var sku = btn.getAttribute('data-sku') || '';

        // Active state
        sizeBtns.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        // Update variant ID
        if (variantInput && variantId) {
          variantInput.value = variantId;
        }

        // Update SKU
        if (skuEl && sku) {
          skuEl.textContent = sku;
        }

        // Update Price (yeni eklendi)
        updatePrice(btn);

        // Update ATC button state
        updateAtcState(available, variantId, btn.getAttribute('data-size-value'));
      });
    });

    function updateAtcState(available, variantId, sizeValue) {
      if (!atcBtn || !atcText) return;
      if (available) {
        atcBtn.classList.remove('is-oos');
        atcBtn.removeAttribute('disabled');
        atcText.textContent = atcLabelAvailable;
        atcBtn.setAttribute('data-action', 'add');
      } else {
        atcBtn.classList.add('is-oos');
        atcText.textContent = atcLabelUnavailable;
        atcBtn.setAttribute('data-action', 'notify');
        atcBtn.removeAttribute('disabled');

        // Notify modal için variant bilgisini sakla
        var notifyVariantId = root.querySelector('[data-notify-variant-id]');
        var notifyVariantTitle = root.querySelector('[data-notify-variant-title]');
        var notifyVariantText = root.querySelector('[data-notify-variant]');
        if (notifyVariantId) notifyVariantId.value = variantId;
        if (notifyVariantTitle) notifyVariantTitle.value = sizeValue || '';
        if (notifyVariantText) notifyVariantText.textContent = sizeValue || '';
      }
    }

    // === ATC: SEPETE EKLE veya HABER VER ===
    if (atcBtn) {
      atcBtn.addEventListener('click', function(e) {
        var action = atcBtn.getAttribute('data-action');
        if (action === 'notify' || atcBtn.classList.contains('is-oos')) {
          e.preventDefault();
          openNotifyModal();
        } else {
          e.preventDefault();
          addToCartAjax();
        }
      });
    }

    // === AJAX ADD TO CART (header.js entegrasyonu) ===
    //
    // Bu tema kendi cart sistemini header.js içinde yönetir. Selectors:
    //   - [data-cart-drawer] (Dawn'ın <cart-drawer>'ı değil)
    //   - [data-cart-toggle] (sepet ikonu)
    //   - [data-cart-close] (kapatma)
    //   - [data-qty-increase] / [data-qty-decrease] (+/-)
    //   - [data-cart-remove] (× silme)
    //   - [data-overlay] (dış karartı)
    //
    // Header.js'in PUBLIC API'sı:
    //   - 'cart:add' event'i fırlat → header.js otomatik refresh + drawer aç
    //   - 'cart:updated' event'i fırlat → header.js otomatik refresh
    //   - window.__edmeOpenCart() → direkt drawer aç
    //
    // Bizim tek işimiz: /cart/add.js çağrısını yap, sonra 'cart:add' event'i
    // fırlat. Geri kalan her şeyi header.js halleder (drawer açma, listener
    // re-attach, count update, vs).
    function addToCartAjax() {
      if (!form || !atcBtn) return;

      // Buton durumu: yükleniyor
      var originalText = atcText ? atcText.textContent : '';
      atcBtn.setAttribute('disabled', 'disabled');
      atcBtn.style.opacity = '0.7';
      if (atcText) atcText.textContent = '...';

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function(response) {
          return response.json().then(function(data) {
            return { ok: response.ok, status: response.status, data: data };
          });
        })
        .then(function(result) {
          // Buton durumunu eski haline al
          atcBtn.removeAttribute('disabled');
          atcBtn.style.opacity = '';
          if (atcText) atcText.textContent = originalText;

          if (!result.ok) {
            var errMsg = (result.data && (result.data.description || result.data.message)) || 'Ürün sepete eklenemedi.';
            console.warn('[EDME ATC] Cart add failed:', result.data);
            alert(errMsg);
            return;
          }

          // BAŞARI: header.js'e haber ver → refresh + drawer açma onun işi
          document.dispatchEvent(new CustomEvent('cart:add'));
        })
        .catch(function(err) {
          atcBtn.removeAttribute('disabled');
          atcBtn.style.opacity = '';
          if (atcText) atcText.textContent = originalText;
          console.error('[EDME ATC] Network error:', err);
          alert('Bağlantı hatası, lütfen tekrar deneyin.');
        });
    }

    // === CART DRAWER × CLOSE BUTON FIX (delegated) ===
    // Sorun: Header.js sayfa yüklendiğinde tek seferlik
    //   document.querySelector('[data-cart-close]').addEventListener(...)
    // ile listener bağlıyor. Ama bizim addToCartAjax sonrası header.js
    // drawer'ın iç HTML'ini refresh ettiği için yeni × butonu listener'sız
    // kalıyor → tıklama çalışmıyor.
    //
    // Çözüm: Document seviyesinde delegated click handler. DOM her
    // değiştiğinde de çalışır çünkü tıklama event'i bubble eder.
    //
    // Global flag ile bir kez kurulur, PDP re-init'lerde duplicate olmaz.
    if (!window.__edmeCartCloseDelegatedInit) {
      window.__edmeCartCloseDelegatedInit = true;

      document.addEventListener('click', function(e) {
        var closeBtn = e.target.closest('[data-cart-close]');
        if (!closeBtn) return;

        // Drawer'ı kapat - header.js'in closeAll() fonksiyonunu tetikleyelim.
        // Doğrudan erişim yok, ama [data-overlay] tıklaması da aynı işi
        // yapıyor (header.js'in overlay click listener'ı closeAll çağırır).
        // Yedek olarak class'ları manuel kaldırıyoruz.
        var cartDrawer = document.querySelector('[data-cart-drawer]');
        if (cartDrawer) {
          cartDrawer.classList.remove('is-open');
          cartDrawer.setAttribute('aria-hidden', 'true');
        }
        var overlay = document.querySelector('[data-overlay]');
        if (overlay) {
          overlay.classList.remove('is-active');
        }
        document.body.classList.remove('cart-open', 'menu-open', 'search-open');
      });
    }

    // === CART STOCK ERROR MODAL ===
    // Dawn'ın cart.js'i +/- veya × ile sepet güncelleme yaptığında
    // PUB_SUB_EVENTS.cartUpdate event'ini yayınlar. Stok yetmiyorsa
    // event içinde cartData.errors alanı dolu olur. Bunu yakalayıp
    // ortada blocking olmayan bir uyarı modalı gösteriyoruz.
    //
    // Global flag ile sadece bir kez subscribe oluruz (PDP re-init'lerde
    // duplicate subscription olmasın).
    setupStockErrorListener();

    function setupStockErrorListener() {
      if (window.__edmeStockErrorListenerInit) return;
      window.__edmeStockErrorListenerInit = true;

      // Modal DOM elementlerini bul. Bunlar Liquid'de section içinde render
      // ediliyor ama position: fixed olduğu için body'nin neresinde olduğu
      // önemli değil — querySelector ile bulunur.
      function getModalEls() {
        return {
          overlay: document.querySelector('[data-stock-error-overlay]'),
          modal: document.querySelector('[data-stock-error-modal]'),
          closeBtn: document.querySelector('[data-stock-error-close]'),
          text: document.querySelector('[data-stock-error-text]')
        };
      }

      var autoCloseTimer = null;

      function openStockErrorModal(message) {
        var els = getModalEls();
        if (!els.modal || !els.overlay || !els.text) {
          // Modal HTML mevcut değilse fallback: alert göster
          // (PDP dışından çağrılırsa olabilir)
          console.warn('[EDME] Stock error modal not in DOM, falling back to alert');
          alert(message);
          return;
        }

        els.text.textContent = message;
        els.overlay.hidden = false;
        requestAnimationFrame(function() {
          els.overlay.classList.add('is-visible');
          els.modal.classList.add('is-open');
        });
        els.modal.setAttribute('aria-hidden', 'false');

        // 5 saniye sonra otomatik kapan
        clearTimeout(autoCloseTimer);
        autoCloseTimer = setTimeout(closeStockErrorModal, 5000);
      }

      function closeStockErrorModal() {
        var els = getModalEls();
        if (!els.modal || !els.overlay) return;

        clearTimeout(autoCloseTimer);
        els.modal.classList.remove('is-open');
        els.overlay.classList.remove('is-visible');
        els.modal.setAttribute('aria-hidden', 'true');
        setTimeout(function() {
          if (els.overlay) els.overlay.hidden = true;
        }, 280);
      }

      // Close button (modal × tıklaması) — document delegation
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-stock-error-close]')) {
          closeStockErrorModal();
          return;
        }
        // Overlay tıklaması da kapatır
        if (e.target.closest('[data-stock-error-overlay]')) {
          closeStockErrorModal();
        }
      });

      // ESC ile kapansın
      document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape') return;
        var els = getModalEls();
        if (els.modal && els.modal.classList.contains('is-open')) {
          closeStockErrorModal();
        }
      });

      // === Dawn cartUpdate event subscriber ===
      // Dawn'ın pubsub.js'i window.subscribe global'ını sağlar.
      // PUB_SUB_EVENTS.cartUpdate Dawn'ın constants'ı; 'cart-update' string'ine
      // eşittir. Hem sembolik hem string kullanımı için iki yöntem deniyoruz.
      //
      // NOT: Bazı Dawn fork tema'ları (örn. bu site) kendi updateLineQty
      // fonksiyonunu kullanır ve Dawn'ın publish() çağrısını yapmaz. Bu durumda
      // pubsub event'i hiç tetiklenmez. Bu yüzden EK olarak fetch interceptor
      // kuruyoruz (aşağıda) — pubsub tetiklenmese bile interceptor çalışır.
      function trySubscribe() {
        if (typeof window.subscribe !== 'function') {
          // pubsub henüz yüklenmemiş olabilir, biraz bekleyip tekrar dene
          return false;
        }

        // Dawn'ın PUB_SUB_EVENTS.cartUpdate değeri pubsub.js'te tanımlı.
        // Çoğu Dawn sürümünde değer 'cart-update' string'idir.
        var eventName = (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) || 'cart-update';

        window.subscribe(eventName, function(eventData) {
          if (!eventData) return;
          // Dawn cart.js: publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
          var cartData = eventData.cartData;
          if (!cartData) return;

          // Stok hatası varsa cartData.errors dolu olur (Shopify backend
          // response'undaki 'errors' alanı). Tipik mesaj:
          // "X isimli ürün için talebiniz kadar stok bulunmamaktadır."
          if (cartData.errors) {
            // errors string olabilir veya object — string'e çevir
            var errMsg = typeof cartData.errors === 'string'
              ? cartData.errors
              : (cartData.description || cartData.message || 'Stok yetersiz.');
            openStockErrorModal(errMsg);
          }
        });

        return true;
      }

      // İlk denemeyi yap; başarısız olursa pubsub yüklenene kadar bekle
      if (!trySubscribe()) {
        var retryCount = 0;
        var retryInterval = setInterval(function() {
          retryCount++;
          if (trySubscribe() || retryCount > 20) {
            clearInterval(retryInterval);
          }
        }, 250);
      }

      // === FETCH INTERCEPTOR (Dawn-fork tema güvenliği için) ===
      // Bazı temalar Dawn'ın publish() çağrısını yapmaz veya kendi cart
      // yönetim sistemini kullanır (bu sitede header.js içinde updateLineQty).
      // Pubsub tetiklenmediğinde de stok hatasını yakalayabilmek için
      // window.fetch'i sarıyoruz: /cart/change.js veya /cart/add.js çağrıları
      // 422 dönerse response body'sini okuyup modal'ı tetikliyoruz.
      //
      // EK MANTIK: 422 görürsek drawer DOM'unu da sunucudan yeniden senkronla.
      // Sebep: header.js'in updateLineQty fonksiyonu UI'ı OPTIMISTIC olarak
      // güncelliyor (önce sayıyı arttırıyor, sonra istek atıyor). Hata gelince
      // rollback yapmıyor → kullanıcı yanlış sayı görüyor. Bizim resync drawer'ı
      // sunucudaki GERÇEK değerlerle güncelliyor.
      //
      // Not: fetch wrapping bir kez yapılır (window.__edmeStockErrorListenerInit
      // flag'i bu fonksiyonun tamamını koruyor zaten).
      var originalFetch = window.fetch;
      window.fetch = function(input, init) {
        var url = '';
        if (typeof input === 'string') {
          url = input;
        } else if (input && input.url) {
          url = input.url;
        }

        var isCartChange = url.indexOf('/cart/change') !== -1;
        var isCartAdd = url.indexOf('/cart/add') !== -1;
        var isCartUpdate = url.indexOf('/cart/update') !== -1;
        var isCartEndpoint = isCartChange || isCartAdd || isCartUpdate;

        var promise = originalFetch.apply(this, arguments);

        if (!isCartEndpoint) {
          return promise;
        }

        // Cart endpoint'i → response'u izle (orijinal response zincirini bozmadan)
        return promise.then(function(response) {
          // Response'u klonla, böylece orijinal kullanıcı response'u tüketebilir
          if (response.status === 422 || !response.ok) {
            response.clone().json().then(function(data) {
              if (!data) return;
              // Shopify cart endpoint hata formatı:
              // { "status": 422, "message": "Cart Error",
              //   "description": "X isimli ürün için talebiniz kadar stok bulunmamaktadır." }
              var errMsg = data.description || data.message || data.errors;
              if (typeof errMsg === 'object') {
                // errors object olabilir (örn: {quantity: "stok yetersiz"})
                var firstKey = Object.keys(errMsg)[0];
                errMsg = firstKey ? errMsg[firstKey] : 'Stok yetersiz.';
              }
              if (errMsg && typeof errMsg === 'string') {
                openStockErrorModal(errMsg);
              }

              // 422 sonrası header.js'e haber ver → drawer'ı kendi refresh etsin.
              // Sebep: header.js'in updateLineQty fonksiyonu UI'ı optimistic
              // güncelliyor (önce sayıyı arttırıyor, sonra istek atıyor). Hata
              // gelince rollback yapmıyor. Biz 'cart:updated' event'i fırlatarak
              // header.js'in kendi refreshCart() metodunu tetikliyoruz → drawer
              // sunucudaki gerçek değerlerle yenilenir.
              if (isCartChange) {
                document.dispatchEvent(new CustomEvent('cart:updated'));
              }
            }).catch(function() {
              // JSON parse edilemezse sessizce devam et
            });
          }
          return response;
        });
      };
    }

    // === STOCK NOTIFY MODAL ===
    var notifyOverlay = root.querySelector('[data-notify-overlay]');
    var notifyModal = root.querySelector('[data-notify-modal]');
    var notifyClose = root.querySelector('[data-notify-close]');
    var notifyForm = root.querySelector('[data-notify-form]');
    var notifyEmail = root.querySelector('[data-notify-email]');
    var notifyPhone = root.querySelector('[data-notify-phone]');
    var notifySuccess = root.querySelector('[data-notify-success]');
    var notifyError = root.querySelector('[data-notify-error]');

    function openNotifyModal() {
      if (!notifyModal || !notifyOverlay) return;
      notifyOverlay.hidden = false;
      requestAnimationFrame(function() {
        notifyOverlay.classList.add('is-visible');
        notifyModal.classList.add('is-open');
      });
      notifyModal.setAttribute('aria-hidden', 'false');
      // Reset
      if (notifySuccess) notifySuccess.hidden = true;
      if (notifyError) notifyError.hidden = true;
    }
    function closeNotifyModal() {
      if (!notifyModal || !notifyOverlay) return;
      notifyModal.classList.remove('is-open');
      notifyOverlay.classList.remove('is-visible');
      notifyModal.setAttribute('aria-hidden', 'true');
      setTimeout(function() {
        notifyOverlay.hidden = true;
      }, 300);
    }

    if (notifyClose) notifyClose.addEventListener('click', closeNotifyModal);
    if (notifyOverlay) notifyOverlay.addEventListener('click', closeNotifyModal);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && notifyModal && notifyModal.classList.contains('is-open')) {
        closeNotifyModal();
      }
    });

    // Notify form submit (Shopify customer endpoint kullanır)
    if (notifyForm) {
      notifyForm.addEventListener('submit', function(e) {
        e.preventDefault();
        if (notifySuccess) notifySuccess.hidden = true;
        if (notifyError) notifyError.hidden = true;

        var email = notifyEmail ? notifyEmail.value.trim() : '';
        var phone = notifyPhone ? notifyPhone.value.trim() : '';

        if (!email && !phone) {
          if (notifyError) {
            notifyError.textContent = 'Lütfen e-posta veya telefon gir.';
            notifyError.hidden = false;
          }
          return;
        }
        if (email && !/\S+@\S+\.\S+/.test(email)) {
          if (notifyError) {
            notifyError.textContent = 'Geçerli bir e-posta gir.';
            notifyError.hidden = false;
          }
          return;
        }

        // Shopify customer endpoint
        var formData = new FormData(notifyForm);
        // Eğer sadece phone varsa, dummy email koy (Shopify zorunlu kıldığı için)
        if (!email && phone) {
          formData.set('contact[email]', 'noemail+' + Date.now() + '@notify.local');
        }
        formData.set('form_type', 'customer');
        formData.set('utf8', '✓');

        fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        }).then(function(res) {
          if (notifySuccess) notifySuccess.hidden = false;
          notifyForm.reset();
          setTimeout(closeNotifyModal, 2200);
        }).catch(function() {
          if (notifyError) {
            notifyError.textContent = 'Bir hata oluştu, lütfen tekrar dene.';
            notifyError.hidden = false;
          }
        });
      });
    }

    // === RELATED COLORS PANEL ===
    var rcolorOverlay = root.querySelector('[data-rcolor-overlay]');
    var rcolorPanel = root.querySelector('[data-rcolor-panel]');
    var rcolorClose = root.querySelector('[data-rcolor-close]');
    var rcolorBody = root.querySelector('[data-rcolor-body]');

    function openRColor(productsData) {
      if (!rcolorPanel || !rcolorOverlay || !rcolorBody) return;
      rcolorBody.innerHTML = renderRColorGrid(productsData);

      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = scrollbarWidth + 'px';
        var stickyHeader = document.querySelector('.header-wrapper, .section-header, header[role="banner"], .shopify-section-header');
        if (stickyHeader) {
          stickyHeader.style.paddingRight = scrollbarWidth + 'px';
          stickyHeader.setAttribute('data-edme-scrollbar-comp', '1');
        }
      }

      rcolorOverlay.hidden = false;
      requestAnimationFrame(function() {
        rcolorOverlay.classList.add('is-visible');
        rcolorPanel.classList.add('is-open');
      });
      rcolorPanel.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeRColor() {
      if (!rcolorPanel || !rcolorOverlay) return;
      rcolorPanel.classList.remove('is-open');
      rcolorOverlay.classList.remove('is-visible');
      rcolorPanel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      var compHeader = document.querySelector('[data-edme-scrollbar-comp="1"]');
      if (compHeader) {
        compHeader.style.paddingRight = '';
        compHeader.removeAttribute('data-edme-scrollbar-comp');
      }
      setTimeout(function() {
        rcolorOverlay.hidden = true;
        if (rcolorBody) rcolorBody.innerHTML = '';
      }, 380);
    }

    function renderRColorGrid(items) {
      if (!items || !items.length) {
        return '<p style="text-align:center;color:#6B6B6B;padding:40px 0;font-size:12px;">Diğer renk bulunamadı.</p>';
      }
      var html = '<div class="edme-pdp__rcolor-grid">';
      items.forEach(function(item) {
        var colorName = item.color || item.title || '';
        html += '<a href="' + escapeAttr(item.url) + '" class="edme-pdp__rcolor-item">';
        html += '  <div class="edme-pdp__rcolor-thumb">';
        if (item.image) {
          html += '    <img src="' + escapeAttr(item.image) + '" alt="' + escapeAttr(item.title || '') + '" loading="lazy">';
        }
        html += '  </div>';
        html += '  <p class="edme-pdp__rcolor-name">' + escapeHtml(colorName) + '</p>';
        html += '</a>';
      });
      html += '</div>';
      return html;
    }

    function escapeHtml(s) {
      if (s == null) return '';
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function escapeAttr(s) {
      if (s == null) return '';
      return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    // Trigger
    root.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-related-trigger]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      var raw = trigger.getAttribute('data-related-products');
      if (!raw) return;
      try {
        var parser = new DOMParser();
        var decoded = parser.parseFromString(raw, 'text/html').documentElement.textContent;
        var products = JSON.parse(decoded);
        openRColor(products);
      } catch (err) {
        console.error('[EDME PDP] Related parse error:', err);
      }
    });

    if (rcolorClose) rcolorClose.addEventListener('click', closeRColor);
    if (rcolorOverlay) rcolorOverlay.addEventListener('click', closeRColor);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && rcolorPanel && rcolorPanel.classList.contains('is-open')) {
        closeRColor();
      }
    });

    // === SCHEMA ACCORDION DRAWER / RIGHT POPUP ===
    var pdpDrawerOverlay = root.querySelector('[data-pdp-drawer-overlay]');
    var pdpDrawer = root.querySelector('[data-pdp-drawer]');
    var pdpDrawerClose = root.querySelector('[data-pdp-drawer-close]');
    var pdpDrawerHeading = root.querySelector('[data-pdp-drawer-heading]');
    var pdpDrawerBody = root.querySelector('[data-pdp-drawer-body]');

    function applyBodyLock(lock, compKey) {
      compKey = compKey || 'data-edme-scrollbar-comp-drawer';

      if (lock) {
        var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = scrollbarWidth + 'px';
          var stickyHeader = document.querySelector('.header-wrapper, .section-header, header[role="banner"], .shopify-section-header');
          if (stickyHeader) {
            stickyHeader.style.paddingRight = scrollbarWidth + 'px';
            stickyHeader.setAttribute(compKey, '1');
          }
        }
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        var compHeader = document.querySelector('[' + compKey + '="1"]');
        if (compHeader) {
          compHeader.style.paddingRight = '';
          compHeader.removeAttribute(compKey);
        }
      }
    }

    function openPdpDrawer(title, html) {
      if (!pdpDrawer || !pdpDrawerOverlay || !pdpDrawerHeading || !pdpDrawerBody) return;

      pdpDrawerHeading.textContent = title || '';
      pdpDrawerBody.innerHTML = html || '';
      pdpDrawerBody.scrollTop = 0;

      applyBodyLock(true, 'data-edme-scrollbar-comp-drawer');
      pdpDrawerOverlay.hidden = false;

      requestAnimationFrame(function() {
        pdpDrawerOverlay.classList.add('is-visible');
        pdpDrawer.classList.add('is-open');
      });

      pdpDrawer.setAttribute('aria-hidden', 'false');
    }

    function closePdpDrawer() {
      if (!pdpDrawer || !pdpDrawerOverlay) return;

      pdpDrawer.classList.remove('is-open');
      pdpDrawerOverlay.classList.remove('is-visible');
      pdpDrawer.setAttribute('aria-hidden', 'true');
      applyBodyLock(false, 'data-edme-scrollbar-comp-drawer');

      setTimeout(function() {
        pdpDrawerOverlay.hidden = true;
        if (pdpDrawerBody) pdpDrawerBody.innerHTML = '';
      }, 380);
    }

    root.addEventListener('click', function(e) {
      var drawerTrigger = e.target.closest('[data-pdp-drawer-trigger]');
      if (!drawerTrigger || !root.contains(drawerTrigger)) return;

      e.preventDefault();

      var parent = drawerTrigger.closest('.edme-pdp__accordion--drawer');
      var source = parent ? parent.querySelector('[data-pdp-drawer-source]') : null;
      var title = drawerTrigger.getAttribute('data-pdp-drawer-title') || drawerTrigger.textContent.trim();
      var html = source ? source.innerHTML : '';

      openPdpDrawer(title, html);
    });

    if (pdpDrawerClose) pdpDrawerClose.addEventListener('click', closePdpDrawer);
    if (pdpDrawerOverlay) pdpDrawerOverlay.addEventListener('click', closePdpDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && pdpDrawer && pdpDrawer.classList.contains('is-open')) {
        closePdpDrawer();
      }
    });

    // === SIZE CHART MODAL ===
    var scTriggers = root.querySelectorAll('[data-size-chart-trigger]');
    var scOverlay = root.querySelector('[data-sc-overlay]');
    var scModal = root.querySelector('[data-sc-modal]');
    var scClose = root.querySelector('[data-sc-close]');

    function openSizeChart() {
      if (!scModal || !scOverlay) return;

      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = scrollbarWidth + 'px';
        var stickyHeader = document.querySelector('.header-wrapper, .section-header, header[role="banner"], .shopify-section-header');
        if (stickyHeader) {
          stickyHeader.style.paddingRight = scrollbarWidth + 'px';
          stickyHeader.setAttribute('data-edme-scrollbar-comp', '1');
        }
      }

      scOverlay.hidden = false;
      requestAnimationFrame(function() {
        scOverlay.classList.add('is-visible');
        scModal.classList.add('is-open');
      });
      scModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeSizeChart() {
      if (!scModal || !scOverlay) return;
      scModal.classList.remove('is-open');
      scOverlay.classList.remove('is-visible');
      scModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      var compHeader = document.querySelector('[data-edme-scrollbar-comp="1"]');
      if (compHeader) {
        compHeader.style.paddingRight = '';
        compHeader.removeAttribute('data-edme-scrollbar-comp');
      }
      setTimeout(function() {
        scOverlay.hidden = true;
      }, 300);
    }

    if (scTriggers && scTriggers.length) {
      scTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          openSizeChart();
        });
      });
    }
    if (scClose) scClose.addEventListener('click', closeSizeChart);
    if (scOverlay) scOverlay.addEventListener('click', closeSizeChart);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && scModal && scModal.classList.contains('is-open')) {
        closeSizeChart();
      }
    });

    // === MOBILE GALLERY CAROUSEL ===
    initGalleryCarousel(root);

    // === RELATED PRODUCTS CAROUSEL ===
    initRelatedCarousel(root);

    // === STİLİ TAMAMLA / ADDITIONAL ===
    initAdditionalProductCarousel(root);

    // === ÜRÜN KARTI GÖRSEL CAROUSEL ===
    initProductCardCarousels(root);

    // === LIGHTBOX ===
    initLightbox(root);
  }

  // ===========================================================================
  // EDME PRODUCT CARD IMAGE CAROUSEL — PDP içinde render edilen product-card için
  // ===========================================================================
  function initProductCardCarousels(scope) {
    var cards = scope.querySelectorAll('[data-pcard-carousel]');
    cards.forEach(function(card) {
      if (card.__edmePcardCarouselInit) return;
      card.__edmePcardCarouselInit = true;

      var media = card.querySelector('.edme-pcard__media');
      var track = card.querySelector('[data-pcard-track]');
      if (!media || !track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('.edme-pcard__slide'));
      var dots = Array.prototype.slice.call(card.querySelectorAll('[data-dot-index]'));
      var prevBtn = card.querySelector('[data-pcard-prev]');
      var nextBtn = card.querySelector('[data-pcard-next]');
      var currentIndex = 0;
      var totalSlides = slides.length;

      if (totalSlides <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }

      function goTo(idx) {
        if (idx < 0) idx = totalSlides - 1;
        if (idx >= totalSlides) idx = 0;
        currentIndex = idx;
        track.style.transform = 'translate3d(-' + (idx * 100) + '%, 0, 0)';

        slides.forEach(function(slide, i) {
          slide.classList.toggle('is-active', i === idx);
        });
        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === idx);
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex - 1);
      });

      if (nextBtn) nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex + 1);
      });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
          if (!isNaN(idx)) goTo(idx);
        });
      });

      var touchStartX = 0;
      var touchStartY = 0;
      var touchDir = null;
      var touchThreshold = 8;
      var swipeDx = 0;

      media.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchDir = null;
        swipeDx = 0;
      }, { passive: true });

      media.addEventListener('touchmove', function(e) {
        var dx = e.touches[0].clientX - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;
        if (touchDir === null) {
          if (Math.abs(dx) > touchThreshold || Math.abs(dy) > touchThreshold) {
            touchDir = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical';
          }
        }
        if (touchDir === 'horizontal') {
          e.preventDefault();
          swipeDx = dx;
        }
      }, { passive: false });

      media.addEventListener('touchend', function(e) {
        if (touchDir === 'horizontal' && Math.abs(swipeDx) > 30) {
          swipeDx < 0 ? goTo(currentIndex + 1) : goTo(currentIndex - 1);
        }
        touchDir = null;
        swipeDx = 0;
      });

      goTo(0);
    });
  }

  function initGalleryCarousel(root) {
    var gallery = root.querySelector('[data-pdp-gallery]');
    var track = root.querySelector('[data-pdp-gallery-track]');
    if (!gallery || !track) return;

    var slides = track.querySelectorAll('.edme-pdp__media');
    var slideCount = slides.length;
    if (slideCount <= 1) return;

    var dots = root.querySelectorAll('[data-dot-index]');
    var prevBtn = root.querySelector('[data-pdp-gallery-prev]');
    var nextBtn = root.querySelector('[data-pdp-gallery-next]');
    var currentIndex = 0;

    function isMobile() {
      return window.innerWidth <= 990;
    }

    function goTo(idx) {
      if (idx < 0) idx = 0;
      if (idx >= slideCount) idx = slideCount - 1;
      currentIndex = idx;

      if (isMobile()) {
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      } else {
        track.style.transform = '';
      }

      slides.forEach(function(s, i) {
        s.classList.toggle('is-active', i === idx);
      });
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === idx);
      });
      updateArrows();
    }

    function updateArrows() {
      if (prevBtn) {
        prevBtn.setAttribute('aria-disabled', currentIndex === 0 ? 'true' : 'false');
      }
      if (nextBtn) {
        nextBtn.setAttribute('aria-disabled', currentIndex === slideCount - 1 ? 'true' : 'false');
      }
    }

    // Arrow clicks
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!isMobile()) return;
        goTo(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!isMobile()) return;
        goTo(currentIndex + 1);
      });
    }

    // Dot click
    dots.forEach(function(dot) {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!isMobile()) return;
        var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
        goTo(idx);
      });
    });

    // Touch swipe (mobile)
    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var touchEndY = 0;
    var isSwiping = false;

    gallery.addEventListener('touchstart', function(e) {
      if (!isMobile()) return;
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
      isSwiping = false;
    }, { passive: true });

    gallery.addEventListener('touchmove', function(e) {
      if (!isMobile()) return;
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      var dx = Math.abs(touchEndX - touchStartX);
      var dy = Math.abs(touchEndY - touchStartY);
      if (dx > dy && dx > 10) {
        isSwiping = true;
      }
    }, { passive: true });

    gallery.addEventListener('touchend', function(e) {
      if (!isMobile() || !isSwiping) return;
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      var threshold = 40;

      if (diff > threshold) {
        goTo(currentIndex + 1);
      } else if (diff < -threshold) {
        goTo(currentIndex - 1);
      }
    }, { passive: true });

    // Resize → desktop'a geçince transform'u temizle
    var lastIsMobile = isMobile();
    window.addEventListener('resize', function() {
      var nowIsMobile = isMobile();
      if (nowIsMobile !== lastIsMobile) {
        lastIsMobile = nowIsMobile;
        if (!nowIsMobile) {
          track.style.transform = '';
          currentIndex = 0;
          slides.forEach(function(s, i) {
            s.classList.toggle('is-active', i === 0);
          });
          dots.forEach(function(d, i) {
            d.classList.toggle('is-active', i === 0);
          });
        } else {
          updateArrows();
        }
      }
    });

    // Initial state
    updateArrows();
  }

  // ===========================================================================
  // RELATED PRODUCTS CAROUSEL
  // - Sonsuz loop (sondan başa)
  // - Desktop: 5.5 ürün, Mobile: 2.5 ürün
  // - Mouse drag (desktop) + touch swipe (mobile)
  // - Sol/sağ ok butonları
  // ===========================================================================
  function initRelatedCarousel(root) {
    var wrap = root.querySelector('[data-related-carousel]');
    if (!wrap) return;

    var viewport = wrap.querySelector('[data-related-viewport]');
    var track = wrap.querySelector('[data-related-track]');
    var prevBtn = wrap.querySelector('[data-related-prev]');
    var nextBtn = wrap.querySelector('[data-related-next]');
    if (!viewport || !track) return;

    var originalSlides = Array.prototype.slice.call(track.children);
    var totalSlides = originalSlides.length;
    if (totalSlides === 0) return;

    // Klonla: sonsuz loop için başa sona kopyalar
    // [son N kopya] [orijinal] [ilk N kopya]
    var visibleCount = function() {
      return window.innerWidth <= 990 ? 2.2 : 5.5;
    };

    // Eğer slide sayısı görünür sayıdan az/eşitse → loop & drag kapalı, statik göster
    var enableLoop = totalSlides > Math.ceil(visibleCount());
    if (!enableLoop) {
      // Statik mod: sadece slide'ları sola hizala, drag/swipe yok
      track.style.transform = 'translate3d(0, 0, 0)';
      track.style.transition = 'none';
      viewport.style.cursor = 'default';
      // Az ürünse ok butonları da gizlensin (CSS'te zaten gizli ama emin olalım)
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    var cloneCount = Math.ceil(visibleCount()) + 1;

    function buildClones() {
      // Önceki klonları temizle
      var existingClones = track.querySelectorAll('[data-clone]');
      existingClones.forEach(function(c) { c.remove(); });

      var startClones = [];
      var endClones = [];

      // Sonraki için: ilk N slide'ı sonuna kopyala
      for (var i = 0; i < cloneCount; i++) {
        var idxNext = i % totalSlides;
        var cloneNext = originalSlides[idxNext].cloneNode(true);
        cloneNext.setAttribute('data-clone', 'end');
        endClones.push(cloneNext);
      }
      // Önceki için: son N slide'ı başına kopyala
      for (var j = 0; j < cloneCount; j++) {
        var idxPrev = (totalSlides - 1 - j + totalSlides) % totalSlides;
        var clonePrev = originalSlides[idxPrev].cloneNode(true);
        clonePrev.setAttribute('data-clone', 'start');
        startClones.push(clonePrev);
      }
      // startClones ters sırayla başa eklenecek
      startClones.reverse();

      // DOM'a ekle
      var firstOrig = track.firstElementChild;
      startClones.forEach(function(c) { track.insertBefore(c, firstOrig); });
      endClones.forEach(function(c) { track.appendChild(c); });
    }

    buildClones();

    // currentIndex = orijinal slide'ın indeksi (0..totalSlides-1)
    // Track içinde: ilk cloneCount adet "start clone", sonra orijinaller, sonra "end clone"
    var currentIndex = 0;

    function getSlideWidth() {
      var firstSlide = track.children[0];
      if (!firstSlide) return 0;
      var rect = firstSlide.getBoundingClientRect();
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.gap) || 0;
      return rect.width + gap;
    }

    function getOffsetForIndex(idx) {
      // Klonlar dahil track içindeki gerçek pozisyon
      var slideW = getSlideWidth();
      // İlk orijinalin offset'i = cloneCount * slideW
      return -((cloneCount + idx) * slideW);
    }

    function setTrackPosition(offset, animate) {
      if (!animate) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '';
      }
      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
      // Reflow zorla — transition reset için
      if (!animate) {
        track.offsetHeight;
        track.style.transition = '';
      }
    }

    function goTo(idx, animate) {
      if (typeof animate === 'undefined') animate = true;
      currentIndex = idx;
      var offset = getOffsetForIndex(idx);
      setTrackPosition(offset, animate);
    }

    function next() {
      var newIdx = currentIndex + 1;
      goTo(newIdx, true);
      // Eğer son orijinali aştıysak, animation bitince başa "teleport"
      if (newIdx >= totalSlides) {
        setTimeout(function() {
          currentIndex = newIdx % totalSlides;
          setTrackPosition(getOffsetForIndex(currentIndex), false);
        }, 520);
      }
    }

    function prev() {
      var newIdx = currentIndex - 1;
      goTo(newIdx, true);
      if (newIdx < 0) {
        setTimeout(function() {
          currentIndex = (newIdx + totalSlides) % totalSlides;
          setTrackPosition(getOffsetForIndex(currentIndex), false);
        }, 520);
      }
    }

    // Initial position
    requestAnimationFrame(function() {
      setTrackPosition(getOffsetForIndex(0), false);
    });

    // Arrow clicks
    if (prevBtn) prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      prev();
    });
    if (nextBtn) nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      next();
    });

    // === DRAG / SWIPE ===
    var isDown = false;
    var startX = 0;
    var startOffset = 0;
    var dragDelta = 0;

    function getCurrentOffset() {
      var transform = window.getComputedStyle(track).transform;
      if (transform === 'none') return 0;
      var match = transform.match(/matrix.*\((.+)\)/);
      if (!match) return 0;
      var values = match[1].split(', ');
      // matrix(a, b, c, d, tx, ty) → tx = values[4]
      // matrix3d daha uzun, ama tx hâlâ index 12
      return parseFloat(values[values.length === 16 ? 12 : 4]) || 0;
    }

    function dragStart(clientX) {
      isDown = true;
      startX = clientX;
      startOffset = getCurrentOffset();
      dragDelta = 0;
      viewport.classList.add('is-dragging');
      track.style.transition = 'none';
    }

    function dragMove(clientX) {
      if (!isDown) return;
      dragDelta = clientX - startX;
      track.style.transform = 'translate3d(' + (startOffset + dragDelta) + 'px, 0, 0)';
    }

    function dragEnd() {
      if (!isDown) return;
      isDown = false;
      viewport.classList.remove('is-dragging');
      track.style.transition = '';

      var slideW = getSlideWidth();
      var threshold = slideW * 0.2; // %20'den fazla sürüklendiyse atla

      if (Math.abs(dragDelta) > threshold) {
        if (dragDelta < 0) {
          next();
        } else {
          prev();
        }
      } else {
        goTo(currentIndex, true);
      }
      dragDelta = 0;
    }

    // Mouse events (desktop drag)
    viewport.addEventListener('mousedown', function(e) {
      // Sadece sol click
      if (e.button !== 0) return;
      e.preventDefault();
      dragStart(e.clientX);
    });
    document.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      dragMove(e.clientX);
    });
    document.addEventListener('mouseup', dragEnd);
    document.addEventListener('mouseleave', dragEnd);

    // === TOUCH (mobile) — yön tespiti ile ===
    var touchStartX = 0;
    var touchStartY = 0;
    var touchDir = null; // 'horizontal' | 'vertical' | null
    var touchDirThreshold = 8; // px

    viewport.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDir = null; // henüz yön tespit edilmedi
      // Drag'i HENÜZ başlatma — yön belli olunca başlat
    }, { passive: true });

    viewport.addEventListener('touchmove', function(e) {
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;

      // İlk hareketle yön tespit et
      if (touchDir === null) {
        if (Math.abs(dx) > touchDirThreshold || Math.abs(dy) > touchDirThreshold) {
          if (Math.abs(dx) > Math.abs(dy)) {
            touchDir = 'horizontal';
            // Yatay swipe başladı → drag'i şimdi başlat
            dragStart(touchStartX);
          } else {
            touchDir = 'vertical';
            // Dikey scroll → carousel'e karışma, sayfa normal scroll
          }
        }
      }

      if (touchDir === 'horizontal') {
        // Sayfayı dikey scroll'lamasın diye preventDefault
        e.preventDefault();
        dragMove(e.touches[0].clientX);
      }
    }, { passive: false }); // ← KRİTİK: preventDefault için passive: false

    viewport.addEventListener('touchend', function(e) {
      if (touchDir === 'horizontal') {
        dragEnd();
      }
      touchDir = null;
    });
    viewport.addEventListener('touchcancel', function(e) {
      if (touchDir === 'horizontal') {
        dragEnd();
      }
      touchDir = null;
    });

    // Drag sırasında accidental click'i engelle (sürükleme bittikten sonra link'e tıklanmasın)
    var lastDragDelta = 0;
    function recordDelta() {
      lastDragDelta = Math.abs(dragDelta);
    }
    viewport.addEventListener('mouseup', recordDelta);
    viewport.addEventListener('touchend', recordDelta);

    viewport.addEventListener('click', function(e) {
      if (lastDragDelta > 8) {
        e.preventDefault();
        e.stopPropagation();
        lastDragDelta = 0;
      }
    }, true);

    // Resize: pozisyonu yeniden hesapla, klonları yeniden oluştur
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        var newCloneCount = Math.ceil(visibleCount()) + 1;
        if (newCloneCount !== cloneCount) {
          cloneCount = newCloneCount;
          buildClones();
        }
        setTrackPosition(getOffsetForIndex(currentIndex), false);
      }, 200);
    });
  }

  // ===========================================================================
  // LIGHTBOX
  // - Click ile aç, hangi görsele tıklandıysa o görselle başla
  // - Sol/sağ ok ile diğer görsellere geç (klavye + buton)
  // - Mouse wheel scroll / pinch ile zoom (1x ↔ 3x)
  // - Zoom yapılmışken mouse drag / parmak drag ile pan
  // - Tıkla ile toggle zoom (1x → 2x veya 2x → 1x)
  // - ESC, ×, dış alana tık → kapat
  // - PRELOAD: önceki/sonraki görsel arkada yüklenir, navigasyon anında olur
  // ===========================================================================
  function initLightbox(root) {
    var lightbox = root.querySelector('[data-lightbox]');
    if (!lightbox) return;

    var dataEl = root.querySelector('[data-lightbox-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (err) {
      console.error('[EDME Lightbox] data parse error:', err);
      return;
    }
    if (!data || !data.images || data.images.length === 0) return;

    var images = data.images;
    var imgEl = lightbox.querySelector('[data-lightbox-img]');
    var imgWrap = lightbox.querySelector('[data-lightbox-img-wrap]');
    var stage = lightbox.querySelector('[data-lightbox-stage]');
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');
    var counter = lightbox.querySelector('[data-lightbox-counter]');
    var zoomHint = lightbox.querySelector('[data-lightbox-zoom-hint]');

    var currentIndex = 0;
    var zoomLevel = 1;
    var panX = 0;
    var panY = 0;

    // Preloaded image cache
    var preloadedImages = {};

    function preloadImage(idx) {
      var normalized = ((idx % images.length) + images.length) % images.length;
      if (preloadedImages[normalized]) return preloadedImages[normalized];
      var img = new Image();
      img.src = images[normalized].src;
      preloadedImages[normalized] = img;
      return img;
    }

    // Komşuları preload et
    function preloadNeighbors(idx) {
      preloadImage(idx);
      preloadImage(idx + 1);
      preloadImage(idx - 1);
    }

    if (images.length <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    }

    function applyTransform() {
      imgWrap.style.transform = 'translate3d(' + panX + 'px, ' + panY + 'px, 0) scale(' + zoomLevel + ')';
    }

    function resetZoom() {
      zoomLevel = 1;
      panX = 0;
      panY = 0;
      imgWrap.classList.remove('is-zoomed');
      applyTransform();
    }

    function showImage(idx) {
      currentIndex = ((idx % images.length) + images.length) % images.length;
      var img = images[currentIndex];

      // Preload edilmiş ise hemen göster (cache'den)
      var preloaded = preloadImage(currentIndex);

      // Smooth transition için fade trick - ama hızlı
      imgEl.style.opacity = '0';
      requestAnimationFrame(function() {
        imgEl.src = img.src;
        imgEl.alt = img.alt || '';
        // Decode et, sonra göster
        if (imgEl.decode) {
          imgEl.decode().then(function() {
            imgEl.style.opacity = '1';
          }).catch(function() {
            imgEl.style.opacity = '1';
          });
        } else {
          imgEl.style.opacity = '1';
        }
      });

      counter.textContent = (currentIndex + 1) + ' / ' + images.length;
      resetZoom();

      // Komşuları preload et
      preloadNeighbors(currentIndex);
    }

    function showZoomHint(text) {
      if (!zoomHint) return;
      var textEl = zoomHint.querySelector('.edme-pdp__lightbox-zoom-text');
      if (textEl) textEl.textContent = text;
      zoomHint.classList.add('is-visible');
      clearTimeout(zoomHint._timer);
      zoomHint._timer = setTimeout(function() {
        zoomHint.classList.remove('is-visible');
      }, 1500);
    }

    function open(idx) {
      lightbox.removeAttribute('hidden');
      requestAnimationFrame(function() {
        lightbox.classList.add('is-open');
      });
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = scrollbarWidth + 'px';
        var stickyHeader = document.querySelector('.header-wrapper, .section-header, header[role="banner"], .shopify-section-header');
        if (stickyHeader) {
          stickyHeader.style.paddingRight = scrollbarWidth + 'px';
          stickyHeader.setAttribute('data-edme-scrollbar-comp-lb', '1');
        }
      }

      showImage(idx);

      // Tüm görselleri arka planda preload et (öncelik: yakın olanlar)
      preloadNeighbors(idx);
      // Sonra geri kalan
      setTimeout(function() {
        for (var i = 0; i < images.length; i++) {
          preloadImage(i);
        }
      }, 100);
    }

    function close() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      var compHeader = document.querySelector('[data-edme-scrollbar-comp-lb="1"]');
      if (compHeader) {
        compHeader.style.paddingRight = '';
        compHeader.removeAttribute('data-edme-scrollbar-comp-lb');
      }
      setTimeout(function() {
        lightbox.setAttribute('hidden', '');
        resetZoom();
      }, 280);
    }

    function next() {
      showImage(currentIndex + 1);
    }
    function prev() {
      showImage(currentIndex - 1);
    }

    // === Trigger: Galeri görsellerine tıklama ===
    var triggers = root.querySelectorAll('[data-lightbox-trigger]');
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        var idx = parseInt(trigger.getAttribute('data-image-index'), 10) || 0;
        open(idx);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    if (stage) {
      stage.addEventListener('click', function(e) {
        if (e.target === stage) {
          close();
        }
      });
    }

    document.addEventListener('keydown', function(e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        close();
      } else if (e.key === 'ArrowRight') {
        next();
      } else if (e.key === 'ArrowLeft') {
        prev();
      }
    });

    imgWrap.addEventListener('click', function(e) {
      e.stopPropagation();
      if (lastPanDelta > 5) {
        lastPanDelta = 0;
        return;
      }
      if (zoomLevel === 1) {
        zoomLevel = 2;
        imgWrap.classList.add('is-zoomed');
        applyTransform();
        showZoomHint('%200');
      } else {
        resetZoom();
        showZoomHint('%100');
      }
    });

    stage.addEventListener('wheel', function(e) {
      e.preventDefault();
      var delta = e.deltaY > 0 ? -0.15 : 0.15;
      var newZoom = Math.min(3, Math.max(1, zoomLevel + delta));
      if (newZoom === zoomLevel) return;
      zoomLevel = newZoom;
      if (zoomLevel > 1) {
        imgWrap.classList.add('is-zoomed');
      } else {
        imgWrap.classList.remove('is-zoomed');
        panX = 0;
        panY = 0;
      }
      applyTransform();
      showZoomHint('%' + Math.round(zoomLevel * 100));
    }, { passive: false });

    var isPanning = false;
    var panStartX = 0;
    var panStartY = 0;
    var panStartPanX = 0;
    var panStartPanY = 0;
    var lastPanDelta = 0;

    imgWrap.addEventListener('mousedown', function(e) {
      if (zoomLevel <= 1) return;
      if (e.button !== 0) return;
      e.preventDefault();
      e.stopPropagation();
      isPanning = true;
      panStartX = e.clientX;
      panStartY = e.clientY;
      panStartPanX = panX;
      panStartPanY = panY;
      lastPanDelta = 0;
      imgWrap.classList.add('is-panning');
    });
    document.addEventListener('mousemove', function(e) {
      if (!isPanning) return;
      var dx = e.clientX - panStartX;
      var dy = e.clientY - panStartY;
      lastPanDelta = Math.max(Math.abs(dx), Math.abs(dy));
      panX = panStartPanX + dx;
      panY = panStartPanY + dy;
      applyTransform();
    });
    document.addEventListener('mouseup', function() {
      if (!isPanning) return;
      isPanning = false;
      imgWrap.classList.remove('is-panning');
    });

    // === Mobile: Pinch + Pan + SWIPE (görsel arası geçiş için) ===
    var touchState = {
      mode: null,
      startX: 0,
      startY: 0,
      startPanX: 0,
      startPanY: 0,
      startDist: 0,
      startZoom: 1,
      lastDelta: 0,
      swipeDx: 0
    };

    function getTouchDist(touches) {
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    stage.addEventListener('touchstart', function(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        touchState.mode = 'pinch';
        touchState.startDist = getTouchDist(e.touches);
        touchState.startZoom = zoomLevel;
      } else if (e.touches.length === 1) {
        if (zoomLevel > 1) {
          // Zoom yapılmışsa pan
          touchState.mode = 'pan';
          touchState.startX = e.touches[0].clientX;
          touchState.startY = e.touches[0].clientY;
          touchState.startPanX = panX;
          touchState.startPanY = panY;
          touchState.lastDelta = 0;
        } else {
          // Zoom yapılmamışsa: yatay swipe ile görsel değiştir
          touchState.mode = 'swipe';
          touchState.startX = e.touches[0].clientX;
          touchState.startY = e.touches[0].clientY;
          touchState.swipeDx = 0;
        }
      } else {
        touchState.mode = null;
      }
    }, { passive: false });

    stage.addEventListener('touchmove', function(e) {
      if (touchState.mode === 'pinch' && e.touches.length === 2) {
        e.preventDefault();
        var dist = getTouchDist(e.touches);
        var scale = dist / touchState.startDist;
        var newZoom = Math.min(3, Math.max(1, touchState.startZoom * scale));
        zoomLevel = newZoom;
        if (zoomLevel > 1) {
          imgWrap.classList.add('is-zoomed');
        } else {
          imgWrap.classList.remove('is-zoomed');
          panX = 0;
          panY = 0;
        }
        applyTransform();
      } else if (touchState.mode === 'pan' && e.touches.length === 1) {
        e.preventDefault();
        var dx = e.touches[0].clientX - touchState.startX;
        var dy = e.touches[0].clientY - touchState.startY;
        touchState.lastDelta = Math.max(Math.abs(dx), Math.abs(dy));
        panX = touchState.startPanX + dx;
        panY = touchState.startPanY + dy;
        applyTransform();
      } else if (touchState.mode === 'swipe' && e.touches.length === 1) {
        // Yön tespiti — yatay daha fazlaysa swipe, dikey ise normal
        var dx = e.touches[0].clientX - touchState.startX;
        var dy = e.touches[0].clientY - touchState.startY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
          e.preventDefault();
          touchState.swipeDx = dx;
        }
      }
    }, { passive: false });

    stage.addEventListener('touchend', function(e) {
      if (touchState.mode === 'swipe') {
        // Swipe threshold: ekranın %20'si
        var swipeThreshold = window.innerWidth * 0.2;
        if (Math.abs(touchState.swipeDx) > swipeThreshold) {
          if (touchState.swipeDx < 0) {
            next();
          } else {
            prev();
          }
        }
      }
      touchState.mode = null;
    });

    imgEl.addEventListener('dragstart', function(e) {
      e.preventDefault();
    });
  }



  // ===========================================================================
  // STİLİ TAMAMLA / ADDITIONAL CAROUSEL — custom.additional1
  // Tablı ürün carousel kodunun tabsız PDP versiyonu
  // Native horizontal scroll + scrollBy + drag + disabled arrow state
  // ===========================================================================
  function initAdditionalProductCarousel(root) {
    var section = root.querySelector('[data-edme-pdp-additional-carousel]');
    if (!section || section.dataset.edmePdpAdditionalCarouselInit === 'true') return;

    section.dataset.edmePdpAdditionalCarouselInit = 'true';

    var track = section.querySelector('[data-edme-apc-track]');
    var prevBtn = section.querySelector('[data-edme-apc-prev]');
    var nextBtn = section.querySelector('[data-edme-apc-next]');
    var dragThreshold = 12;

    if (!track) return;

    function getScrollAmount() {
      var card = track.querySelector('.edme-pdp-additional-carousel__item');
      var multiplier = parseInt(section.getAttribute('data-scroll-step'), 10) || 2;

      if (!card) return 300 * multiplier;

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;

      return (card.offsetWidth + gap) * multiplier;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;

      var maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
      var currentLeft = track.scrollLeft;
      var threshold = 4;

      var atStart = currentLeft <= threshold;
      var atEnd = currentLeft >= maxScrollLeft - threshold;
      var noOverflow = maxScrollLeft <= threshold;

      prevBtn.disabled = noOverflow || atStart;
      nextBtn.disabled = noOverflow || atEnd;

      prevBtn.classList.toggle('is-disabled', noOverflow || atStart);
      nextBtn.classList.toggle('is-disabled', noOverflow || atEnd);
    }

    function bindDragScroll() {
      if (track.dataset.additionalDragBound === 'true') return;
      track.dataset.additionalDragBound = 'true';

      var pointerDown = false;
      var isDragging = false;
      var startX = 0;
      var startLeft = 0;
      var activePointerId = null;

      track.addEventListener('pointerdown', function(event) {
        if (event.pointerType === 'touch') return;
        if (event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea')) return;

        pointerDown = true;
        isDragging = false;
        startX = event.clientX;
        startLeft = track.scrollLeft;
        activePointerId = event.pointerId;
      });

      track.addEventListener('pointermove', function(event) {
        if (!pointerDown) return;

        var diff = event.clientX - startX;

        if (!isDragging && Math.abs(diff) < dragThreshold) {
          return;
        }

        if (!isDragging) {
          isDragging = true;
          track.classList.add('is-dragging');
          if (track.setPointerCapture) track.setPointerCapture(activePointerId);
        }

        event.preventDefault();
        track.scrollLeft = startLeft - diff;
      });

      function endDrag(event) {
        if (!pointerDown) return;

        pointerDown = false;

        if (isDragging) {
          track.dataset.wasDragged = 'true';

          window.setTimeout(function() {
            delete track.dataset.wasDragged;
          }, 0);
        }

        isDragging = false;
        activePointerId = null;
        track.classList.remove('is-dragging');

        try {
          if (track.releasePointerCapture) track.releasePointerCapture(event.pointerId);
        } catch (err) {}

        window.requestAnimationFrame(updateArrows);
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      track.addEventListener('click', function(event) {
        if (track.dataset.wasDragged === 'true') {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
    }

    bindDragScroll();

    track.addEventListener('scroll', function() {
      window.requestAnimationFrame(updateArrows);
    }, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });

        window.requestAnimationFrame(updateArrows);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });

        window.requestAnimationFrame(updateArrows);
      });
    }

    window.addEventListener('resize', function() {
      window.requestAnimationFrame(updateArrows);
    }, { passive: true });

    section.querySelectorAll('.edme-pdp-additional-carousel__item img').forEach(function(img) {
      if (img.complete) {
        window.requestAnimationFrame(updateArrows);
      } else {
        img.addEventListener('load', function() {
          window.requestAnimationFrame(updateArrows);
        }, { once: true });
      }
    });

    window.requestAnimationFrame(updateArrows);
    window.setTimeout(updateArrows, 250);
    window.setTimeout(updateArrows, 700);
  }
  function initAll() {
    document.querySelectorAll('[data-edme-pdp]').forEach(initPDP);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector) {
      e.target.querySelectorAll('[data-edme-pdp]').forEach(function(el) {
        el.__edmePdpInit = false;
        initPDP(el);
      });
    }
  });
})();